import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthState } from '@/hooks/useAuth'

export function OnboardingGuard({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { user, loading: authLoading } = useAuthState()
  const [routingDecisionMade, setRoutingDecisionMade] = useState(false)

  useEffect(() => {
    console.log('[OnboardingGuard] Evaluating routing:', {
      authLoading,
      isAuthenticated: !!user,
      pathname: location.pathname,
      onboardingCompleted: localStorage.getItem('onboarding-completed'),
    })

    if (authLoading) {
      console.log('[OnboardingGuard] Waiting — auth still loading')
      return
    }

    // Bypass onboarding guard for test routes
    if (
      location.pathname === '/test-grid'
    ) {
      setRoutingDecisionMade(true)
      return
    }

    if (location.pathname === '/letsgo') {
      console.log('[OnboardingGuard] Already on /letsgo, no redirect needed')
      setRoutingDecisionMade(true)
      return
    }

    if (localStorage.getItem('onboarding-completed') === 'true') {
      console.log('[OnboardingGuard] onboarding-completed found in localStorage — skipping onboarding')
      setRoutingDecisionMade(true)
      return
    }

    if (user) {
      console.log('[OnboardingGuard] User is authenticated — skipping onboarding')
      setRoutingDecisionMade(true)
      return
    }

    console.log('[OnboardingGuard] Anonymous session — allowing routes without onboarding redirect')
    setRoutingDecisionMade(true)
  }, [authLoading, user, location.pathname])

  // Block all route rendering until routing decision is made
  if (!routingDecisionMade) {
    return <></>
  }

  return <>{children}</>
}
